<app-dialog-header [title]="isAdvanceWithdraw ? 'Adiantamento de saque' : 'Solicitação de saque'"></app-dialog-header>

<mat-dialog-content>
  @if (!hasAvailableBalance) {
    <p class="text-danger" role="alert">{{ unavailableMessage }}</p>
  }
  <p>
    {{ isAdvanceWithdraw ? "Saldo disponível para adiantamento" : "Saldo disponível" }}:
    {{ accountBalance | currency: "BRL" }}
  </p>
  <div class="form-group">
    <label class="form-label" for="value">Valor</label>
    <div>
      <input
        placeholder="Valor do saque"
        type="text"
        class="form-control"
        id="value"
        min="0"
        [max]="accountBalance"
        [formControl]="requestValue"
        (input)="onInput($event)" />

      @if (requestValue.touched && requestValue.hasError("required")) {
        <div class="text-danger">Esse campo é obrigatório.</div>
      }
      @if (requestValue.touched && requestValue.hasError("minAmount")) {
        <div class="text-danger">Informe um valor maior que zero.</div>
      }
      @if (requestValue.touched && requestValue.hasError("invalidAmount")) {
        <div class="text-danger" role="alert">{{ submitError || unavailableMessage }}</div>
      }
      @if (submitError && !requestValue.hasError("invalidAmount")) {
        <div class="text-danger" role="alert">{{ submitError }}</div>
      }
    </div>
  </div>

  @if (!isAdvanceWithdraw && requiresInvoice) {
    <div class="form-group mt-3">
      <label class="form-label" for="invoice">Nota fiscal</label>
      <input
        id="invoice"
        type="file"
        class="form-control"
        [accept]="acceptedInvoiceTypes"
        (change)="onInvoiceSelected($event)" />
      @if (invoiceFile) {
        <p class="mt-2 mb-0">Arquivo: {{ invoiceFile.name }}</p>
      }
      @if (invoiceError) {
        <div class="text-danger mt-1" role="alert">{{ invoiceError }}</div>
      }
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="gap-2">
  <app-button styleType="outlined" [disabled]="submitting" (btnClick)="dialogRef.close()">Fechar</app-button>
  <app-button
    [loading]="submitting"
    [disabled]="!hasAvailableBalance || submitting || (invoiceRequiredForSubmit && !invoiceFile)"
    (btnClick)="confirm()">
    Solicitar Saque
  </app-button>
</mat-dialog-actions>
